/**
 *
 * DiaogWrap
 *
 */

import React, { memo, FunctionComponent, Children } from 'react';
import { StyledDialog } from './styles';
import { Column, Wrap } from '../../assets/styledAssets/grid';
import { accentColorPrim } from '../../assets/styledAssets/vars';

interface IProps {
  children?: any;
  title?: string;
  actions?: any;
}

const DiaogWrap: FunctionComponent<IProps> = ({ children, title, actions }) => {
  return (
    <StyledDialog>
      {title &&
      <Wrap
        fs={'3rem'}
        color={accentColorPrim}
        fw={'bold'}
        margin={'0 3rem 4rem 3rem'}
      >
        {title}
      </Wrap>}
      <Wrap grow={'1'}>
        <Column flexCol stretch padding={'0'}>{Children.toArray(children)}</Column>
      </Wrap>
    </StyledDialog>
  );
};

export default memo(DiaogWrap);
